"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEpigraphCss = void 0;
const getEpigraphCss = (themeId) => {
    return `
    .${themeId} .epigraph{
      padding-top: 33.33%;
    }
  `;
};
exports.getEpigraphCss = getEpigraphCss;
